module.exports = __webpack_public_path__ + "img/4F4E5F34.5520e12e.png";